import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { ContainerOverlayAnalise } from './styled';

//COMPONENTS
import { Render } from '../../../../../../../../../../../../../../../../Components/CustomUi/render';

interface PropsOverlayAnalise {
    /** Tipo | profundidade escolhido no controle lateral. Vazio = pontos ocultos. */
    tipo_analise_selecionada: string
    fullscreen: boolean
}

/**
 * Aviso sobre o mapa quando nenhum tipo de análise foi escolhido — sem análise os
 * markers não são renderizados, então o mapa vazio precisa explicar o motivo.
 *
 * Em tela cheia não aparece: lá a seleção fica na sidebar, sempre visível.
 */
export const OverlayAnalise: React.FC<PropsOverlayAnalise> = ({ tipo_analise_selecionada, fullscreen }) => {

    return (
        <Render condition={!tipo_analise_selecionada && !fullscreen}>
            <ContainerOverlayAnalise>
                <FontAwesomeIcon icon={faWarning} />
                Selecione o tipo de análise | profundidade para mostrar os pontos
            </ContainerOverlayAnalise>
        </Render>
    )
}
